import { Component, effect, ChangeDetectionStrategy } from '@angular/core';
import { Unit, Role } from '@xanadu/model';
import { NodeComponent } from '@xanadu/core';


@Component({
    selector: 'app-role-node',
    templateUrl: './role-node.component.html',
    styleUrls: ['./role-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoleNodeComponent extends NodeComponent {
    protected get nodeType(): string | undefined {
        return 'role';
    }

    private iconRoot = 'supervised_user_circle';
    private iconUnit = 'folder_shared';
    private iconRole = 'admin_panel_settings';

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model?.node instanceof Unit) {
                if (model.node.parentId) {
                    this.icon = this.iconUnit;
                } else {
                    this.icon = this.iconRoot;
                }
            } else if (model?.node instanceof Role) {
                this.icon = this.iconRole;
            }
        });
    }
}
